import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.9,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

export function UploadIcon(props: IconProps) {
  return <svg {...base} {...props}><path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5"/><path d="M5 14v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4"/></svg>;
}

export function DownloadIcon(props: IconProps) {
  return <svg {...base} {...props}><path d="M12 4v12m0 0-4.5-4.5M12 16l4.5-4.5"/><path d="M5 19.5h14"/></svg>;
}

export function ShareIcon(props: IconProps) {
  return <svg {...base} {...props}><circle cx="18" cy="5" r="2.5"/><circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="19" r="2.5"/><path d="m8.2 10.8 7.6-4.4m-7.6 6.8 7.6 4.4"/></svg>;
}

export function RefreshIcon(props: IconProps) {
  return <svg {...base} {...props}><path d="M20 7v5h-5"/><path d="M4 17v-5h5"/><path d="M18.4 9A7 7 0 0 0 6.1 6.2L4 8m2 7a7 7 0 0 0 12.3 2.8L20 16"/></svg>;
}

export function LockIcon(props: IconProps) {
  return <svg {...base} {...props}><rect x="5" y="10" width="14" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>;
}

export function StoryIcon(props: IconProps) {
  return <svg {...base} {...props}><rect x="7" y="2.5" width="10" height="19" rx="2"/></svg>;
}

export function ProfileIcon(props: IconProps) {
  return <svg {...base} {...props}><circle cx="12" cy="12" r="9.5"/><circle cx="12" cy="9" r="3"/><path d="M6.5 18a6.3 6.3 0 0 1 11 0"/></svg>;
}
